<template>
  <v-layout column fill-height :style="{'background':setDarkMode?'#3e3e3e':'white'}">
    <v-snackbar  :value="errorMsg" color="error" :timeout="5000" top>
      {{errorMsg}}
      <v-btn
        light
        flat
        text
        @click="errorMsg=''"
      >
      Close
      </v-btn>
    </v-snackbar>
    <v-snackbar  v-model="infoSnack" color="info" :timeout="3000" top>
      {{ infoSnakText }}
      <v-btn
        light
        flat
        text
        @click="infoSnack = false"
      >
        Close
      </v-btn>
    </v-snackbar>

        <!-- <div class="loading" v-if="error">
          <v-layout align-center justify-center row fill-height>
            <v-progress-circular :size="25" :width="3" color="grey" indeterminate >
               </v-progress-circular>
          </v-layout>
        </div> -->
        <!-- <camera :dialog="dialogState"
                @closeDialog="dialogState = $event"
                @captureImage="captureImage = $event">

        </camera> -->
       <v-flex xs12 align-space-around>
            <v-expand-transition :hide-on-leave="true">
              <app-header class="browser_autocomplete_top browser_mode" v-if="content" :dark="setDarkMode" :hideBackPage="true" :hideRefresh="true" :hideSearch="true" :hideBackPagee="true" :hideMenu="true" :hideTitle="true" :style="{'background':setDarkMode?'#3e3e3e':'white'}">
                  <v-flex xs12 slot="left" align-center>
                    <v-btn :dark="setDarkMode"  class="top_logo"  size="35"   depressed flat icon @click="content=''"><v-icon>home</v-icon></v-btn>

                    <v-layout xs12 align-start justify-center row>
                        <!-- <v-avatar style="margin-left: -35px;margin-right: 5px;" size="40" tile="tile" class="hidden-sm-and-up" @click="goToLiveMode()"><img :src="JJ" /></v-avatar> -->

                        <v-flex xs11 sm11 md8 lg6 style="position:relative;">
                          <v-btn  @click="jjMenuToggle = !jjMenuToggle" class="browser_floatbtn_top" :class="{'xs_mode':$vuetify.breakpoint.xs}"  fab light  small>
                                      <v-icon :style="{display:'inline-flex'}" v-if="!jjMenuToggle">add</v-icon>
                                      <v-icon :style="{display:'inline-flex'}" v-if="jjMenuToggle">close</v-icon>
                          </v-btn>
                          <vue-autosuggest xs12 md8
                            ref="search"
                            :class="{'autosuggest_input':$vuetify.breakpoint.xs, 'mic_input' : !micStatus}"
                            style="margin-left:30px;"

                            class="autosuggest_top"
                            :value="searchInput"
                            :suggestions="[{data:items}]"
                            @selected="searching"
                            :limit="10"
                            v-on:keyup.enter="searching"
                            @input="onSearchChange"
                            :input-props="{id:'autosuggest__input', placeholder:'topic or expression', 'ref': 'search'}">

                            <template slot-scope="{suggestion}">
                              <div ripple class="my-suggestion-item">{{suggestion.item}}</div>
                            </template>
                          </vue-autosuggest>
                          <v-btn v-if="micStatus" class="browser_sticker_top"  :style="[micStatus ? {'margin-left':'-40px'} : {'margin-left': '-80px'}]" fab light  x-small @click="setInputSearch('>>')">
                            >
                          </v-btn>
                           <v-btn v-if="micStatus" class="browser_bot_top"  :style="[micStatus ? {'margin-left':'-75px'} : {'margin-left': '-150px'}]" fab light  x-small @click="setInputSearch('@@')">
                            @
                          </v-btn>
                          <v-btn v-if="micStatus" class="browser_cmd_top"  :style="[micStatus ? {'margin-left':'-75px'} : {'margin-left': '-150px'}]" fab light  x-small @click="setInputSearch('==')">
                            =
                          </v-btn>

                          <v-btn v-if="micStatus" class="browser_cmd_top"  :style="[micStatus ? {'margin-left':'-75px'} : {'margin-left': '-150px'}]" fab light  x-small @click="setInputSearch('//')">
                            /
                          </v-btn>
                          

                        <v-btn v-if="!micStatus" @click.stop="searching()" class="browser_search" :style="[micStatus ? {'margin-left':'-5px'} : {'margin-left': '-43px'}]"  flat="flat" icon="icon" color="primary">
                            <v-icon :style="{display:'inline-flex'}">search</v-icon>
                        </v-btn>
                        <v-btn  v-if="micStatus" class="browser_cam_top"  :class="{'xs_mode':$vuetify.breakpoint.xs}" :style="[$vuetify.breakpoint.xs ? {'margin-right':'-10px'} : {}]"  fab light  small>
                            <v-icon :style="{display:'inline-flex'}">mic</v-icon>
                        </v-btn>
                        </v-flex>
                    </v-layout>
                  </v-flex>
              </app-header>
              <!-- <v-toolbar class="browser_autocomplete_box browser_toolbar" v-if="content" light>

              </v-toolbar> -->
           </v-expand-transition>
          <v-progress-linear v-if="isLoading && content" class="linear_loading" height="4" :indeterminate="true"></v-progress-linear>

           <v-expand-transition duration="200" :hide-on-leave="true">
                  <v-layout v-if="!content" xs12 align-start justify-center row fill-height>
                    <v-progress-linear v-if="isLoading" style="position: absolute;top: 0;" class="linear_loading" height="4" :indeterminate="true"></v-progress-linear>
                    <v-card   class="yp_card_main" >
                        <v-card-text>
                          <v-layout align-center justify-center column>
                            <v-flex xs12>
                              <v-avatar class="browser_avatar hidden-xs-only" size="100" tile="tile" ><img :src="JJ" /></v-avatar>
                              <v-avatar class="browser_avatar hidden-sm-and-up" style="margin-bottom:-30px;" size="80" tile="tile" ><img :src="JJ" /></v-avatar>
                          </v-flex>
                          </v-layout>
                        </v-card-text>
                        <v-card-text :style="[$vuetify.breakpoint.xs ? {'padding-left':'6px','padding-right':'0'} : {}]">
                             <header-state :dark="setDarkMode" @changeMode="setDarkMode=!setDarkMode"></header-state>
                             <v-btn class="chat_menu" @click.stop="goToLiveMode()"  flat="flat" icon="icon" color="primary">
                                <v-icon :style="{display:'inline-flex'}" size="30">chat</v-icon>
                             </v-btn>
                             <v-flex class="browser_autocomplete_box browser_mode" :class="{'xs12' : micStatus, 'xs12': !micStatus }" sm10 offset-sm1 md8 offset-md2>
                                <v-layout row  align-start justify-start>
                                  <v-btn @click="jjMenuToggle = !jjMenuToggle" class="browser_floatbtn" :class="{'xs_mode':$vuetify.breakpoint.xs}" fab light  small>
                                      <v-icon :style="{display:'inline-flex'}" v-if="!jjMenuToggle">add</v-icon>
                                      <v-icon :style="{display:'inline-flex'}" v-if="jjMenuToggle">close</v-icon>
                                  </v-btn>
                                  <vue-autosuggest
                                    ref="search"
                                    :class="{'autosuggest_input':$vuetify.breakpoint.xs,'autosuggest_input_center': !micStatus}"
                                    style="width:100%"
                                    v-model="searchInput"
                                    :suggestions="[{data:items}]"
                                    @selected="searching"
                                    :limit="10"
                                    v-on:keyup.enter="searching"
                                    @input="onSearchChange"
                                    :input-props="{id:'autosuggest__input', placeholder:'topic or expression', ref: 'search'}">

                                    <template slot-scope="{suggestion}">
                                      <div ripple class="my-suggestion-item">{{suggestion.item}}</div>
                                    </template>
                                </vue-autosuggest>
                                
                                <v-btn v-if="micStatus" class="browser_sticker"  :style="[micStatus ? {'right':'5px'} : {'right': '100px'}]" fab light  small @click="setInputSearch('>>')">
                                  >
                                </v-btn>
                                 <v-btn v-if="micStatus" class="browser_bot"  :style="[micStatus ? {'right':'40px'} : {'right': '150px'}]" fab light  small @click="setInputSearch('@@')">
                                  @
                                </v-btn>
                                <v-btn v-if="micStatus" class="browser_cmd"  :style="[micStatus ? {'right':'75px'} : {'right': '100px'}]" fab light  small @click="setInputSearch('//')">
                                  /
                                </v-btn>
                                    
                                <v-btn v-if="!micStatus" @click.stop="searching()"  class="browser_search" flat="flat" icon="icon" color="primary">
                                    <v-icon :style="{display:'inline-flex'}">search</v-icon>
                                </v-btn>
                                <v-btn v-if="micStatus" class="browser_cam"  :class="{'xs_mode':$vuetify.breakpoint.xs}" fab light  small>
                                  <v-icon :style="{display:'inline-flex'}">mic</v-icon>
                                </v-btn>
                              </v-layout>
                           </v-flex>
                        </v-card-text>
                        <v-slide-x-transition duration="200">
                          <v-card-text v-if="jjMenuToggle">
                              <v-flex style="padding-left: 50px;" :class="{'xs10' : micStatus, 'xs12': !micStatus }" sm10 offset-sm1 md8 offset-md2>
                                <v-layout align-center justify-space-around row>
                                  <template v-for="(item,index) in shortcut.slice(0,shortcut.length/2)" >
                                    <div :key="index">
                                      <v-btn fab :dark="setDarkMode" @click="()=>{content=item.label.toLowerCase();jjMenuToggle=false;}">
                                        <v-icon>{{item.icon}}</v-icon>
                                      </v-btn>
                                      <div class="menu_label hidden-sm-and-down" :style="{'color':setDarkMode?'white':'black'}">{{item.label}}</div>
                                    </div>
                                  </template>
                                </v-layout>
                              </v-flex>
                              <v-flex style="padding-left: 50px;margin-top:35px;" :class="{'xs10' : micStatus, 'xs12': !micStatus }" sm10 offset-sm1 md8 offset-md2>
                                <v-layout align-center justify-space-around row>
                                  <template v-for="(item,index) in shortcut.slice(shortcut.length/2)" >
                                    <div :key="index">
                                      <v-btn fab :dark="setDarkMode" @click="()=>{content=item.label.toLowerCase();jjMenuToggle=false;}">
                                        <v-icon>{{item.icon}}</v-icon>
                                      </v-btn>
                                      <div class="menu_label hidden-sm-and-down" :style="{'color':setDarkMode?'white':'black'}">{{item.label}}</div>
                                    </div>
                                  </template>
                                </v-layout>
                              </v-flex>
                          </v-card-text>
                        </v-slide-x-transition>
                        <v-slide-x-transition duration="200" mode="out-in">
                          <v-card-text v-if="content=='nearby'" >
                            <v-flex  xs12 sm10 offset-sm1 md8 offset-md2>
                              <v-layout align-center justify-space-around row>
                                <SearchResultList  :searchResult="searchQueryResult" :searching="querySearching"/>
                              </v-layout>
                            </v-flex>
                          </v-card-text>
                        </v-slide-x-transition>
                    </v-card>
                  </v-layout>
          </v-expand-transition>
          <v-card  v-if="content" class="yp_card_main yp_card_result">
            <v-slide-x-transition duration="200">
                <v-card-text v-if="jjMenuToggle">
                    <v-flex  xs12 sm10 offset-sm1 md8 offset-md2>
                      <v-layout align-center justify-space-around row>
                        <template v-for="(item,index) in shortcut.slice(0,shortcut.length/2)" >
                          <div :key="index">
                            <v-btn fab :dark="setDarkMode" @click="()=>{content=item.label.toLowerCase();jjMenuToggle=false;}">
                              <v-icon>{{item.icon}}</v-icon>
                            </v-btn>
                            <div class="menu_label hidden-sm-and-down" :style="{'color':setDarkMode?'white':'black'}">{{item.label}}</div>
                          </div>
                        </template>
                      </v-layout>
                    </v-flex>
                    <v-flex style="margin-top:35px;" xs12 sm10 offset-sm1 md8 offset-md2>
                      <v-layout align-center justify-space-around row>
                        <template v-for="(item,index) in shortcut.slice(shortcut.length/2)" >
                          <div :key="index">
                            <v-btn fab :dark="setDarkMode" @click="()=>{content=item.label.toLowerCase();jjMenuToggle=false;}">
                              <v-icon>{{item.icon}}</v-icon>
                            </v-btn>
                            <div class="menu_label hidden-sm-and-down" :style="{'color':setDarkMode?'white':'black'}">{{item.label}}</div>
                          </div>
                        </template>
                      </v-layout>
                    </v-flex>
                </v-card-text>
              </v-slide-x-transition>
              <v-scale-transition mode="out-in">
                  <v-card-text v-if="content=='nearby'" >
                    <v-flex  xs12 sm10 offset-sm1 md12 offset-md0>
                      <v-layout align-center justify-space-around row>
                        <SearchResultList  :searchResult="searchQueryResult" :searching="querySearching"/>
                      </v-layout>
                    </v-flex>
                  </v-card-text>
              </v-scale-transition>
              <v-scale-transition>
                 <v-flex v-if="content == 'console'" xs10 offset-xs1 md8 offset-md2>
                  <v-list  class="list" expand>
                    <template v-for="(item, index) in jjConsoleList" class="list-item">
                      <v-list-tile class="console_item" :key="item.title" avatar>
                        <v-layout align-start justify-start row>
                            <v-flex >
                              <v-list-tile-content class="event-action"  >
                                <v-list-tile-title class="event_default" :class="{'event_error' : item.type == 'error'}" >{{ item.data }}</v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                        </v-layout>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-flex>
              </v-scale-transition>
                <v-list  v-if="model" class="yp_list">
                 <template v-for="(item, index) in response">
                    <v-list-tile  :key="index" @click.stop="editYp(item, index)" class="yp_list_item" >
                        <v-layout align-start justify-start row>
                            <template v-for="(value, key) in item">
                             <v-list-tile-action class="yp_action_tile" :key="key">
                              <v-list-tile-sub-title v-text="key"></v-list-tile-sub-title>
                              <v-list-tile-title v-text="value"></v-list-tile-title>
                            </v-list-tile-action>
                            </template>
                        </v-layout>
                         <v-list-tile-action>
                            <v-btn @click.stop="dupplicateYp(item, index)" outline color="indigo"  fab small light>
                                <v-icon>filter_none</v-icon>
                            </v-btn>
                        </v-list-tile-action>
                    </v-list-tile>
               </template>
              </v-list>

          </v-card>
       </v-flex>
       <!-- <app-footer></app-footer> -->

    </v-layout>
</template>

<script>
import get from 'lodash/get';
import JJ from '@/assets/jujue_icon.png';
import webmms from "webmms-client";
import { set as setCookie, get as getCookie, remove as removeCookie } from "es-cookie";
import { setTimeout } from 'timers';
import { VueAutosuggest } from 'vue-autosuggest';
import Camera from '@/components/browser/Camera';
import HeaderState from '@/components/HeaderLogin';
import AppHeader from '@/components/Header';
import AppFooter from '@/components/Footer';
import SearchResultList from '@/components/nearby/SearchResultList';
import conf from '@/config/config';
import suggesions from '@/assets/json/suggesion';

export default {
  name: 'Browser',
  data() {
    return {
      JJ,
      shortcut:[
        {
          icon:"online_prediction",
          label:"Nearby"
        },
        {
          icon:"account_box",
          label:"Upload"
        },
        {
          icon:"arrow_downward",
          label:"Scan"
        },
        {
          icon:"room",
          label:"Cam"
        },
        {
          icon:"description",
          label:"Devices"
        },
        {
          icon:"file_copy",
          label:"QRun"
        },
        {
          icon:"account_box",
          label:"Contact"
        },
        {
          icon:"arrow_downward",
          label:"Help"
        },
        {
          icon:"room",
          label:"pin"
        },
        {
          icon:"description",
          label:"Object"
        }              
      ],
      setDarkMode:false,
      suggesionList: suggesions,
      value: '',
      model: null,
      searchInput: "",
      querySearching:false,
      searchQuery:"",
      searchQueryResult:[],
      loading: false,
      isLoading: false,
      successed: false,
      micStatus: true,
      dialogState: false,
      dialogLoading: false,
      captureImage: null,
      fab: false,
      jjMenuToggle: false,
      jjConsoleList: [],
      pageRegExp: /^(page)(:)*(\/)*(\/)*([a-z]*)([^&\?\=]*)$/g,
      config: {
        app: '',
        // ddn: 'W6mMVtS9',
        ddn: '>>jj-portal',
        websockURL: conf.wsurl,
        topic: '',
      },
      eiInfo: {
        eiName: '',
        eiTag: '',
        ddn : ''
      },
      webmmsOptions : {
          EiToken: '',
          SToken: '',
          UToken: ''
      },
      yp:{
        ddn: '>>jj-portal',
        //topic: 'jj-exp://parse',
        topic: 'jj://portal',
        func: 'parse',
        args: null
      },
      response: null,
      suggession: [

      ],
      infoSnack: false,
      infoSnakText: 'Sent successful',
      error: false,
      errorMsg: '',
      timeout: 3000,
      timeoutSearch: null,
      mmsReady: false,
      mms: null,
      content:''
    };
  },
  components : {
    VueAutosuggest,
    Camera,
    HeaderState,
    AppHeader,
    AppFooter,
    SearchResultList
  },
  watch: {
    setDarkMode(val){
      setCookie('jj-DarkMode',val?1:0,{ expires: 365 ,path:''});
    },
    content(val){
      console.log(val);
    },
     async searchInput(val) {
       this.micStatus = !this.searchInput;
         if (!this.searchInput) {
          this.suggession = [];
          return;
        }

        if(this.searchInput.toLowerCase().startsWith('page://'))
        {
           setTimeout(()=>{
              this.suggession = [
              // 'page://view',
              // 'page://list',
              // 'page://post',
              // 'page://rss',
              // 'page://sticker',
              // 'page://url',
              // 'page://yp',
              // 'page://youtube',
              // 'page://board',
              // 'page://display'
            ];
            let suggession = this.readSuggession(this.searchInput);
            if(suggession && suggession.length > 0){
                let len = suggession.length > 10 ? 10 : suggession.length;
                for (let index = 0; index < len; index++) {
                  this.suggession.splice(0,0, suggession[index]);
                }
            }
           }, 50);

        }
         else if(this.searchInput.toLowerCase().startsWith('//'))
        {
            this.suggession = this.suggesionList.map((item)=>{
                return `//${item}`;
            });
        }
        else if(this.searchInput.toLowerCase().startsWith('/'))
        {
            this.suggession =  this.suggession = this.suggesionList.map((item)=>{
                return `/${item}`;
            });;
        }
        else{
           this.suggession = [];
           let suggession = this.readSuggession(this.searchInput);
            if(suggession && suggession.length > 0){
                let len = suggession.length > 10 ? 10 : suggession.length;
                for (let index = 0; index < len; index++) {
                  this.suggession.splice(0,0, suggession[index]);
                }
            }
        }

      },
      model(val){
        if(val)
        {
          this.checkInput();
        }
      }
  },
  computed: {
    items () {
      return this.suggession;
    }
  },
  created() {
    this.setDarkMode=getCookie('jj-DarkMode')=='1'?true:false;
    this.readQueryParam();
    this.startMMS();
  },
   async beforeMount() {
      await this.subscribeMMS();
  },
  beforeDestroy() {
    this.removeEvent();
  },
  methods: {
    populateDeviceSearchResult(result){
      if(result.ErrCode==0)
        this.searchQueryResult=result.result.length>0?result.result/*.filter(e=>e.EiName!=null)*/:[{EiName:'No result'}];
      else{
        this.error=true;
        switch(result.ErrCode){
            case -32001:
              this.errorMsg="Retreiving device timeout,Please specify device or type";
              break;
            default:
              this.errorMsg="Retreiving device error";
            break;
          }
        console.log('retreiving device error.');
      }
      this.querySearching=false;
      this.isLoading = false;
    },
    onDeviceSearchClick(){
      if(!this.mmsReady){
        console.log("mms not ready.");
        return;
      }
      this.content='nearby';
      this.querySearching=true;
      if(this.searchQuery.length>0){
          this.mms.socket.emit('request', {
                     func: 'search',
                     data: { SToken: this.webmmsOptions.SToken ,"Keyword":this.searchQuery}
                 }, reply=>this.populateDeviceSearchResult(reply));
      }else{
        this.mms.nearby().then(reply=>this.populateDeviceSearchResult(reply));
      }
  },
    goToLiveMode(){
        this.$router.push('/live');
    },
    readQueryParam(){
          const { lib } = this.$route.query;
          this.config.websockURL = lib ? `https://${lib}` : conf.wsurl;
      },
    checkInput(){
        if(this.searchInput.toLowerCase().startsWith('page://')){
            this.storeSuggession(this.searchInput);
            let path = this.searchInput.substring(this.searchInput.indexOf('//') + 2);
            console.log(path);
            //this.$router.push(path);
            switch(path){
              case 'jboard':
                window.location.href = `https://jboard.ypcloud.com/`;
              break;
            }
              
            window.location.href = `https://git.page/${path}`
        }
         if(this.searchInput.toLowerCase().startsWith('/page')){
            this.storeSuggession(this.searchInput);
            let path = this.searchInput.substring(this.searchInput.indexOf('/page ') + 6);
            console.log(path);
            //this.$router.push(path);
            window.location.href = `https://git.page/${path}`
        }
         if(this.searchInput.toLowerCase().startsWith('//')){
            this.storeSuggession(this.searchInput);
            let path = this.searchInput.substring(this.searchInput.indexOf('//') + 2);
            console.log(path);
            //this.$router.push(path);
            window.location.href = `https://git.page/${path}`
        }
        if(this.searchInput.toLowerCase().startsWith('@@')){
            this.storeSuggession(this.searchInput);
            let path = this.searchInput.substring(this.searchInput.indexOf('@@') + 2);
            console.log(path);
            window.location.href = `https://git.page/chat/${path}`
            //this.$router.push(path);
        }
    },
    storeSuggession(val){
      let suggession = [];

        if(localStorage.getItem("suggession"))
          suggession = JSON.parse(localStorage.getItem('suggession'));
        if(suggession.filter(c=>c == val.toLowerCase()).length == 0)
            suggession.push(val.toLowerCase());
        localStorage.setItem('suggession', JSON.stringify(suggession));
    },
    readSuggession(filter){
        if(!filter)
          return [];
        if(localStorage.getItem("suggession"))
        {
          let suggession = JSON.parse(localStorage.getItem('suggession'));
          return suggession.filter(c => c.startsWith(filter.toLowerCase()));

        }else{
          return [];
        }
    },
    searchFocus(){
      this.$refs.search.$refs.search.focus();
    },
    setInputSearch(text){
      this.searchInput = text;
      this.$refs.search.$refs.search.click();
    },
    consoleLog(data, type){
        this.jjConsoleList.push({data: data, type: type});
    },
    onSearchChange(text){
      this.searchInput = text;
      this.micStatus = !this.searchInput;
    },
    async searching(option){
        if(option)
          this.searchInput = option.item;
        if (!this.searchInput) {
          this.suggession = [];
          return;
        }
        if (this.isLoading) return;

        console.log(this.searchInput);

        if(!this.searchInput.toLowerCase().startsWith('page://') && !this.searchInput.toLowerCase().startsWith('/page') && !this.searchInput.toLowerCase().startsWith('//') && !this.searchInput.toLowerCase().startsWith('@@'))
        {
          this.isLoading = true;
          this.storeSuggession(this.searchInput);
          //console.log(this.searchInput.slice(2),this.searchInput.slice(this.searchInput.indexOf(' ')+1));
          if(this.searchInput.startsWith('>>')){
            switch(this.searchInput.slice(2).split(' ')[0]){
              case 'nearby':
                this.content='nearby';
                this.querySearching=true;
                await this.mms.socket.emit('request', {
                     func: 'nearby',
                     data: { SToken: this.webmmsOptions.SToken}
                 }, reply=>this.populateDeviceSearchResult(reply));
                break;
              case 'search':
                this.content='nearby';
                this.querySearching=true;
                await this.mms.socket.emit('request', {
                     func: 'search',
                     data: { SToken: this.webmmsOptions.SToken , Keyword:this.searchInput.split(' ')[1]}
                 }, reply=>this.populateDeviceSearchResult(reply));
                break;

            }
          }
          else
            await this.sendMMS(this.searchInput);
          this.isLoading = false;
        }else if(this.searchInput.toLowerCase().startsWith('/help')){

        }
        else{
           setTimeout(() => {
              this.checkInput();
           }, 10);
        }
    },
    submit() {
      this.loading = true;
      this.sendMMS(this.value);
    },
    async sendMMS(payload) {
      if(!this.checkWebMMSState())
        return;
      this.content='console';
      const { ddn, topic } = this.yp;
      let res = await this.mms.sendMMS({
        DDN : ddn,
        topic : topic,
        payload: {
          data : payload,
          source : { app : 'jj-br', type: '.page'}
        }
      });
      this.loading = false;
      this.infoSnack = true;
      console.log(res);
      this.consoleLog(`SendMMS response: ${JSON.stringify(res)}`, 'log');
      //this.response = [];
      // if(error == 'OK'){

      // }else{
      //     this.errorMsg = error;
      //     this.error = true;
      // }
    },
    async callMMS(payload,func='parse') {
      const { ddn, topic } = this.yp;
      let res = await this.mms.callMMS({
        DDN : ddn,
        topic : topic,
        func: func,
        payload: payload
      });
      this.loading = false;
      console.log(res);
      this.response = [];
      // if(error == 'OK'){

      // }else{
      //     this.errorMsg = error;
      //     this.error = true;
      // }
    },
    checkWebMMSState(){
      if(!this.mmsReady)
      {
        this.errorMsg = "WebMMS is not connected or registered.";
        this.error = true;
        return false;
      }else return  true;

    },
    startMMS() {
      this.mms =  webmms({
        wsurl: this.config.websockURL,
        EiToken: getCookie("jj-EiToken") || "",
        SToken: getCookie("jj-SToken") || ""
      });
    },
     async subscribeMMS() {
        this.removeEvent = this.mms.on("registered", async reply => {
            //console.log('reply=%s', JSON.stringify(reply))
             if(reply.ErrMsg == "OK"){
                this.eiInfo.ddn = reply.result.DDN;
                this.webmmsOptions.EiToken = reply.result.EiToken;
                this.webmmsOptions.SToken = reply.result.SToken;
                this.webmmsOptions.UToken = reply.result.UToken;
                if(this.eiInfo.eiName == ''){
                  this.eiInfo.eiName = reply.result.EiName ? reply.result.EiName : 'jjBR' + this.makeId(5);
                }
                 if(this.eiInfo.eiTag == ''){
                  this.eiInfo.eiTag = reply.result.EiTag ? reply.result.EiTag : '';
                }
             }

             let expiredTime = 60 * 60 * 24 * 30 * 12;

             setCookie("jj-EiToken", this.webmmsOptions.EiToken);
             setCookie("jj-SToken", this.webmmsOptions.SToken);


             console.log('regtoCenter: %s', reply.ErrMsg);
             this.consoleLog(`regtoCenter: ${reply.ErrMsg}`, 'log');

             this.mmsReady = true;
             this.error = false;
             let deviceInfo = {"DDN":this.eiInfo.ddn,"EiOwner":"","EiName":this.eiInfo.eiName,"EiType":".page","EiTag":this.eiInfo.eiTag,"EiLoc":""};
             let result = await this.mms.setDeviceInfo(deviceInfo);

             console.log('SetDevice reply=%s', JSON.stringify(result));
            //  this.consoleLog(`SetDevice reply: ${JSON.stringify(result)}`, 'log');
        });

        this.mms.on('message', (method, from, data, body) => {
            this.mmsReady = true;
            this.error = false;
            console.log('rcve: from=%s, data=%s', JSON.stringify(from), JSON.stringify(data));
            this.consoleLog(`rcve: from: ${JSON.stringify(from)}, data=${JSON.stringify(data)}`, 'log');
        });

        this.mms.on('state', msg => {
            console.log('WS error: %s', msg);
            this.consoleLog(`WS error: ${msg}`, 'error');
            this.errorMsg = `WS error: ${msg}`;
            this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('disconnect', msg => {
            console.log('disconnect error: %s', msg);
            this.consoleLog(`disconnect error: ${msg}`, 'error');
            this.mmsReady = false;
            // this.errorMsg = `disconnect error: ${msg}`;
            // this.error = true;
        });

        this.mms.on('error', err => {
            console.log('error: %s', err);
            this.consoleLog(`error: ${err}`, 'error');
            this.mmsReady = false;
            //this.errorMsg = `error: ${err}`;
            //this.error = true;
        });

        this.mms.on('connect_error', err => {
            console.log('connect_error: %s', err);
            this.consoleLog(`connect_error: ${err}`, 'error');
            this.mmsReady = false;
            // this.errorMsg = `connect_error: ${err}`;
            // this.error = true;
        });

        this.mms.on('connect_timeout', err => {
            console.log('connect_timeout: %s', err);
            this.consoleLog(`connect_timeout: ${err}`, 'error');
            this.mmsReady = false;
            // this.errorMsg = `connect_timeout: ${err}`;
            // this.error = true;
        });
      }
  },
};
</script>

<style scoped>
.chat_menu{
  position: absolute;
  left: 5px;
  top: 0;
  width: 43px;
  height: 43px;
}
.list{
    box-shadow: 0 0 7px 1px #cbc6c6;
    margin-top: 60px;
    min-height: 260px;
    margin-bottom: 40px;
}
.yp_card{
  /* height: 90%; */
}
.yp_card_main{
  box-shadow: none;
  background-color: transparent;
  border-color:transparent;
  width: 100%;
  position: inherit;

}
.yp_card_result{
 margin-top: 80px;
}
.yp_list{
   background-color:#fafafa;
}

.yp_editor{
  min-height: 500px;
  height: 100%;
}
.yp_action_tile{
  margin-left: 10px;
}
.yp_list_item{
      margin-bottom: 15px;

}
.list-item{
    border-bottom: 1px solid #c9c8c8;
}
.event_default{
  color:#00464e;
  font-size: 10pt;
}
.top_logo{
  margin-right: 15px;
  margin-top: 5px;
  position: absolute;
    /* position: absolute;
    left: 62px;
    top: 7px;
    z-index: 3; */
}
.top_logo.xs_mode{
  left: 55px;
}
 .event_error{
    color:#bd0303 !important;
  }
  .browser_toolbar{
    position: absolute !important;
    left: 0;
    right: 0;
    top: 0;
  }
.browser_autocomplete{
  margin-top: 7px  !important;
}
.browser_autocomplete_main{
  margin-top: -40px !important;
}
.browser_autocomplete_top{
    /* margin-left: -20px !important; */
}
.browser_avatar{
  margin-top: 40px !important;
  cursor: pointer;
}
.browser_autocomplete_box{
  position: relative;
  background-color: transparent !important;
  box-shadow: none;
  margin-top: 10px !important;
    padding-right: 5px !important;
    padding-left: 5px !important;
}
.browser_autocomplete_top{
   background-color: transparent !important;
  box-shadow: none;
  margin-top:8px !important;
}
.browser_floatbtn{
  margin-top: 8px;
   height: 30px;
    width: 30px;
    /* position: absolute;
    top: -3px;
    left: -50px; */
}
.browser_floatbtn_top{
  margin-top: 0;
  position: absolute;
  left:-15px;
  top:7px;
  z-index: 3;
   height: 30px;
    width: 30px;
}

.xs_mode{
  height: 30px;
    width: 30px;
}
.xs_mode.browser_floatbtn{
  margin-top: 7px;
  margin-left: -6px;
}

.browser_cam{
   position: absolute !important;
    left: 52px !important;
    top: 3px !important;
    height: 30px;
    width: 30px;
}
.browser_cam_top{
     position: absolute !important;
    left:30px !important;
    top: 3px !important;
    width: 30px;
    height:30px;
}
.browser_cam_top.xs_mode{
    left: 30px !important;
}
.xs_mode.browser_cam{
    left: 36px !important;
    top: 1px !important;
}
.browser_search{
    position: absolute !important;
    right: 0 !important;
    top: 0 !important;
}
.browser_mic{
    position: absolute !important;
    right: 50px;
    top: 0 !important;
}
.browser_near{
   position: absolute !important;
    right: 110px;
    width: 30px;
    height: 30px;
    top: 2px !important;
    box-shadow: unset !important;
    font-weight: bold;
}
.browser_sticker{
    position: absolute !important;
    right: 5px;
    width: 30px;
    height: 30px;
    top: 2px !important;
    box-shadow: unset  !important;
    font-weight: bold;
}
.browser_cmd{
  position: absolute !important;
    right: 75px;
    width: 30px;
    height: 30px;
    top: 2px !important;
    box-shadow: unset  !important;
    font-weight: bold;
}
.browser_bot{
  position: absolute !important;
    right: 40px;
    width: 30px;
    height: 30px;
    top: 2px !important;
    box-shadow: unset !important;
    font-weight: bold;
}

.browser_sticker_top{
    position: absolute !important;
    right: 5px;
    width: 30px;
    height: 30px;
    top: 2px !important;
    box-shadow: unset  !important;
    font-weight: bold;
}
.browser_cmd_top{
  position: absolute !important;
    right: 75px;
    width: 30px;
    height: 30px;
    top: 2px !important;
    box-shadow: unset  !important;
    font-weight: bold;
}
.browser_bot_top{
   position: absolute !important;
    right: 40px;
    width: 30px;
    height: 30px;
    top: 2px !important;
    box-shadow: unset !important;
    font-weight: bold;
}
.browser_near_top{
   position: absolute !important;
    right: 110px;
    width: 30px;
    height: 30px;
    top: 2px !important;
    box-shadow: unset !important;
    font-weight: bold;
}
.linear_loading{
      margin: 0 !important;
}
.loading{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left:0;
  z-index: 50;
  background-color: rgba(255, 255, 255, 0.4196078431372549);
}

.menu_label{
  text-align: center;
  font-size: 11pt;
  font-weight: bold;
}
.console_item{
      height: 30px;
}
</style>
<style>

.v-input__prepend-outer{
      margin-right: 0 !important;
}
.browser_autocomplete .v-input__slot{
  border-radius: 24px !important;
}
.browser_autocomplete .v-input__slot input{
  margin-left: 10px !important;
}
.browser_autocomplete .v-input__append-inner {
  padding-left: 57px !important;
}
.v-autocomplete__content{
  border-radius: 15px !important;
}

#autosuggest__input {

      outline: none;
      position: relative;
      display: block;
      background-color: #fff;
      width: 100%;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      border-radius: 30px;
      padding: 5px;
      height: 47px;
      font-size: 12pt;
        padding-left: 50px;
      box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
          -webkit-box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    }
    .autosuggest_input #autosuggest__input{
      font-size: 10pt;

    }

    .browser_mode  #autosuggest__input{
      padding-left: 50px !important;
    }

    .autosuggest_top #autosuggest__input{
         padding-left: 55px !important;
    }

    .autosuggest_input_center #autosuggest__input{
         padding-left: 20px !important;
    }



    .autosuggest_input_top{
      margin-left:28px !important;
    }

    /* .autosuggest_top.mic_input #autosuggest__input{
         padding-left: 20px;
    } */

    #autosuggest__input.autosuggest__input-open {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    .autosuggest__results-container {
      position: relative;
      width: 100%;
    }

    .autosuggest__results {
      font-weight: 300;
      margin: 0;
      position: absolute;
      z-index: 10000001;
      width: 100%;
      border: 1px solid #e0e0e0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background: white;
      padding: 0px;
      overflow-y:scroll;
      max-height: 300px;
      border-radius: 18px;
    }

    .browser_mode .autosuggest__results {

    }

    .autosuggest__results ul {
      list-style: none;
      padding-left: 0;
      margin: 0;
    }

    .autosuggest__results .autosuggest__results-item {
      cursor: pointer;
      padding: 15px;
    }

    #autosuggest ul:nth-child(1) > .autosuggest__results_title {
      border-top: none;
    }

    .autosuggest__results .autosuggest__results_title {
      color: gray;
      font-size: 11px;
      margin-left: 0;
      padding: 15px 13px 5px;
      border-top: 1px solid lightgray;
    }

    .autosuggest__results .autosuggest__results-item:active,
    .autosuggest__results .autosuggest__results-item:hover,
    .autosuggest__results .autosuggest__results-item:focus,
    .autosuggest__results .autosuggest__results-item.autosuggest__results-item-highlighted {
      background-color: #ddd;
    }
</style>

